/** Código http que devuelve el backend en caso de código
 *  OTP incorrecto. */
export const ERROR_OTP_HTTP_CODE = 401;

export const ERROR_SERVER_HTTP_CODE = 500;
